import { useEffect, useState } from "react";

export const useMouseTouchPosition = () => {
	const [pos, setPos] = useState({ x: 0, y: 0 });

	useEffect(() => {
		const updateMousePosition = (e: any) => {
			const x = e.clientX;
			const y = e.clientY;

			setPos((prev) => {
				if (prev.x !== x || prev.y !== y) {
					return { x, y };
				}

				return prev;
			});
		};

		const updateTouchPosition = (e: any) => {
			const x = e.touches[0].clientX;
			const y = e.touches[0].clientY;

			setPos((prev) => {
				if (prev.x !== x || prev.y !== y) {
					return { x, y };
				}

				return prev;
			});
		};

		window.addEventListener("mousemove", updateMousePosition);
		window.addEventListener("touchmove", updateTouchPosition);

		return () => {
			window.removeEventListener("mousemove", updateMousePosition);
			window.removeEventListener("touchmove", updateTouchPosition);
		};
	}, []);

	return pos;
};
